import React, { useEffect, useState } from "react";
import { Modal, Button, Card } from "react-bootstrap";
import BhareeLeadsPage from "./BhareeLeadsPage";
import BhareeBoosterPage from "./BhareeBoosterPage";
import { useLocation } from "react-router-dom";
import { getApi } from "../../actions/structure.action";
import { useDispatch, useSelector } from "react-redux";
import isEmpty from "../../utils/is-Empty";

const BhareeSubscription = ({ pageType }) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const city = params.get("city");
  const state = params.get("state");
  const district = params.get("district");
  const dispatch = useDispatch();
  const [fulfillmentCities, setFulfillmentCities] = useState([]);
  const [boosterData, setBoosterData] = useState([]);
  const [leadsData, setLeadsData] = useState([]);
  const { subscriptionPlans, appconfig } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    getApi("getSubscriptionPlans", dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (appconfig?.data?.length > 0) {
      const cities =
        appconfig.data.find((item) => item.name === "fulfillment_cities")?.value?.split(",") || [];
      setFulfillmentCities(cities);
    }
  }, [appconfig]);

  useEffect(() => {
    if (
      !isEmpty(subscriptionPlans) &&
      !isEmpty(fulfillmentCities) &&
      Array.isArray(subscriptionPlans.data) &&
      subscriptionPlans.data.length > 0
    ) {
      const isFound = fulfillmentCities.includes(city);
      if (isFound) {
        const boosterPlans = subscriptionPlans.data.filter((el) => el.plan_type === "booster");
        setBoosterData(boosterPlans);
      } else {
        const leadsPlans = subscriptionPlans.data.filter((el) => el.plan_type === "leads");
        setLeadsData(leadsPlans);
      }
    }
  }, [subscriptionPlans, fulfillmentCities, city]);

  switch (pageType) {
    case "leads":
      return (
        <>
          <BhareeLeadsPage
            city={city}
            district={district}
            state={state}
            subscriptionData={leadsData}
          />
        </>
      );
    case "booster":
      return (
        <>
          <BhareeBoosterPage
            city={city}
            district={district}
            state={state}
            subscriptionData={boosterData}
          />
        </>
      );
    default:
      return <>This is Bharee Subscription Page</>;
  }
};

export default BhareeSubscription;
